export default function About() {
  return (
    <section id="about" className="bg-[#FAF8F5] py-24">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-center">
          {/* Left Content Panel */}
          <div className="lg:col-span-3">
            <div className="mb-8">
              <span className="text-xs uppercase tracking-wider text-gray-600 font-medium">• ABOUT THE AUTHOR</span>
            </div>
            
            <div className="relative mb-8">
              <div className="text-8xl text-gray-300 font-serif absolute -top-6 -left-4">"</div>
              <blockquote className="relative pl-12">
                <p className="font-serif text-4xl md:text-5xl leading-tight text-gray-900 mb-6">
                  From darkness into light, through faith and resilience
                </p>
              </blockquote>
            </div>

            <div className="flex items-center gap-3 mb-8">
              <h3 className="text-lg font-bold text-gray-900">Melinda Holcomb</h3>
              <div className="flex items-center gap-1">
                <i className="ri-checkbox-circle-fill text-teal-600 text-lg"></i>
                <span className="text-sm text-gray-600">Verified Author</span>
              </div>
            </div>

            <div className="prose prose-lg text-gray-700 leading-relaxed space-y-4">
              <p>
                Melinda Holcomb is a survivor of childhood trauma whose journey to healing has led her from diagnoses of Dissociative Identity Disorder (DID), Post-Traumatic Stress Disorder (PTSD), and Bipolar Disorder to one of spiritual wholeness.
              </p>
              <p>
                Ms. Holcomb leads others down an introspective path into her personal story of survival, testimony of God's faithfulness and Love, and intense psychological challenges with the intent of providing hope to and helping those attempting to overcome similar traumatic obstacles.
              </p>
              <p>
                She shares poems, Scripture and anecdotes that tell her story of survival as she struggled to emerge from the darkness and into the light of healing through therapy, faith, and an inner strength that guided her to survive, and thrive despite circumstances given her.
              </p>
            </div>
          </div>

          {/* Right Visual Panel */}
          <div className="lg:col-span-2">
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/0c0d2fd7f8546543a11e4b60db83227b.jpg"
                  alt="Pilgrimage Toward The Light - Book Cover"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-teal-600 rounded-full opacity-20 blur-3xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}